import { Effect, BlendFunction } from 'postprocessing';
import { Uniform } from 'three';

const FRAGMENT = /* glsl */ `
uniform float exposure;

void mainImage(const in vec4 inputColor, const in vec2 uv, out vec4 outputColor) {
  outputColor = vec4(inputColor.rgb * exposure, inputColor.a);
}
`;

/**
 * Prosté škálování HDR hodnot před tone mappingem.
 *
 * ToneMappingEffect z postprocessing v režimu ACES žádnou expozici neexponuje
 * a Preethamova obloha vrací hodnoty, které bez korekce vypálí celý obraz.
 * Tohle je ten chybějící knob — a zároveň jediné místo, kde se později bude
 * řídit adaptace na denní dobu nebo vstup do jeskyně.
 */
export class ExposureEffect extends Effect {
  constructor(exposure = 0.5) {
    super('ExposureEffect', FRAGMENT, {
      blendFunction: BlendFunction.SRC,
      uniforms: new Map([['exposure', new Uniform(exposure)]]),
    });
  }

  get exposure(): number {
    return this.uniforms.get('exposure')!.value as number;
  }

  set exposure(value: number) {
    this.uniforms.get('exposure')!.value = value;
  }
}
